import React from 'react';
import { observer } from 'mobx-react';
import useMapConfig from './useMapConfig';

const withMapConfig = (Component) => {
  const WrappedComponent = observer((props) => {
    const mapConfig = useMapConfig();
    return <Component {...props} {...mapConfig} />;
  });

  return WrappedComponent;
};

export default withMapConfig;
